import {request} from '../utils/request';
import {GET, POST, PUT} from '../constants/API_CONSTANTS';
import {
  CREATE_CASHBACK_SETTINGS,
  GET_CASHBACK_SETTINGS,
  GET_CASHBACK_SUMMARY,
  UPDATE_CASHBACK_SETTINGS
} from '../constants/API_ENDPOINTS';

const getCashbackSummaryApi = async (locationId) => {
  return request(GET, GET_CASHBACK_SUMMARY(locationId));
};

export const getCashbackSettingsApi = async (locationId) => {
  return request(GET, GET_CASHBACK_SETTINGS(locationId), null, {silent: true});
};

export const createCashbackSettingsApi = async (payload) => {
  return request(POST, CREATE_CASHBACK_SETTINGS(), {data: payload});
};

export const updateCashbackSettingsApi = async (campaignId, payload) => {
  return request(PUT, UPDATE_CASHBACK_SETTINGS(campaignId), {data: payload});
};

export default getCashbackSummaryApi;
